"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 8px;\n  border-radius: 16px;\n  width: fit-content;\n  font-size: ", ";\n  font-weight: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 8px;\n  border-radius: 16px;\n  width: fit-content;\n  font-size: ", ";\n  font-weight: ", ";\n"])), theme_1.default.fontSizes.xxsmall, theme_1.default.fontWeights.bolder);
exports.MainContainer = MainContainer;
var templateObject_1;
//# sourceMappingURL=styles.js.map